import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_JobShowDetail = _resolveComponent("JobShowDetail")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.job.id)
      ? (_openBlock(), _createBlock(_component_JobShowDetail, {
          key: 0,
          data: _ctx.job
        }, null, 8, ["data"]))
      : _createCommentVNode("", true)
  ]))
}